"use client"
/* */
import { jsx } from 'react/jsx-runtime';
import * as Aria from 'react-aria-components';
import { Children, isValidElement, cloneElement } from 'react';
import { mergeRefs } from '@react-aria/utils';

const ReactAriaControlledValueFix = (props) => {
  const { inputContext: context, children } = props;
  const child = Children.only(children);
  if (!isValidElement(child)) {
    throw new Error("Expected valid element");
  }
  const inputProps = child.props;
  const ref = inputProps["ref"];
  const [contextProps, contextRef] = Aria.useContextProps(
    inputProps,
    ref,
    context
  );
  const mergedRef = mergeRefs((el) => {
    if (el instanceof HTMLInputElement || el instanceof HTMLTextAreaElement) {
      el.value = String(contextProps.value ?? "");
    }
  }, contextRef);
  const uncontrolledContextProps = {
    ...contextProps,
    value: void 0,
    ref: mergedRef
  };
  const uncontrolledInputProps = {
    ...inputProps,
    ref: void 0,
    value: void 0
  };
  return /* @__PURE__ */ jsx(Aria.Provider, { values: [[context, uncontrolledContextProps]], children: cloneElement(child, uncontrolledInputProps) });
};

export { ReactAriaControlledValueFix };
//# sourceMappingURL=ReactAriaControlledValueFix.mjs.map
